import { isValidEmailAddress, fadeOutNotifications } from '../functions';
import Swal from 'sweetalert2';

$(document).ready(function() {

	const searchWidget = {
        isLoading: false,
        pickupLocationsPopup: false,
        returnLocationsPopup: false,
        init() {
            $(document).on('click', '.check-availability-btn', this, this.checkAvailability);
            $(document).on('click', '#pickup-location-trigger', this, this.showPickupLocations);
            $(document).on('click', '#return-location-trigger', this, this.showReturnLocations);
            $(document).on('change', '#return_to_other_location', this, this.returnToOtherLocation);
            $(document).on('change', '#from-time', this, this.changeFromTime);
            $(document).on('click', '.search-widget-select-pickup-location', this, this.selectPickupLocation);
            $(document).on('click', '.search-widget-select-return-location', this, this.selectReturnLocation);
            $(document).on('click', '.search-calendar-trigger', this, this.showCalendar);
            $(document).on('click', '.close-calendar', this, this.closeCalendar);

			$(document).on('change', '#pickup_location_select', function() {
				$('#pickup_location').val($(this).val());
			});
			$(document).on('change', '#return_location_select', function() {
				$('#return_location').val($(this).val());
			});

			this.pickupLocationsPopup = new bootstrap.Offcanvas('#pickup-locations-wrapper');
			this.returnLocationsPopup = new bootstrap.Offcanvas('#return-locations-wrapper');

			// const datePopup = new bootstrap.Offcanvas('#datePopup')
			// const triggerBtnDate = document.getElementById('input_hour');
			
			// triggerBtnDate.addEventListener('click', event => {
			// 	datePopup.show();
			// })

			const triggerTabList = document.querySelectorAll('#pickup-location-pills-tab button');
			triggerTabList.forEach(triggerEl => {
				const tabTrigger = new bootstrap.Tab(triggerEl)

				triggerEl.addEventListener('mouseover', event => {
					event.preventDefault()
					tabTrigger.show()
				})
			});

			const triggerTabList2 = document.querySelectorAll('#return-location-pills-tab button');
			triggerTabList2.forEach(triggerEl => {
				const tabTrigger = new bootstrap.Tab(triggerEl)

				triggerEl.addEventListener('mouseover', event => {
					event.preventDefault()
					tabTrigger.show()
				})
			});

			/*window.addEventListener('click', function(e){
				if (document.getElementById('calendar-wrapper')) {
					if (document.getElementById('calendar-wrapper').contains(e.target)){
						//console.log('Clicked in box');
					} else{
						if(e.target.id != 'search-calendar-trigger') {
							//console.log('Clicked outside the box');
							$('#calendar-wrapper').addClass('visually-hidden');
						}
					}
				}

				if(document.getElementById('pickup-locations-wrapper')) {
					if (document.getElementById('pickup-locations-wrapper').contains(e.target)){
						//console.log('Clicked in box');
					} else{
						if(e.target.id != 'pickup-location-trigger') {
							//console.log('Clicked outside the box');
							$('#pickup-locations-wrapper').addClass('hidden');
						}
					}
				}

				if(document.getElementById('return-locations-wrapper')) {
					if (document.getElementById('return-locations-wrapper').contains(e.target)){
						//console.log('Clicked in box');
					} else{
						if(e.target.id != 'return-location-trigger') {
							//console.log('Clicked outside the box');
							$('#return-locations-wrapper').addClass('hidden');
						}
					}
				}
			});*/
        },
		changeFromTime(event) {
			const _this = event.data;
			event.preventDefault();

			$('#to-time').val($('#from-time option:selected').val());
		},
		closeCalendar(event) {
			const _this = event.data;
			event.preventDefault();

			let type = $(this).data('type');
			if (type == '1') {
				if ($('#pickup_location').val() != '' &&
					$('#date-from').val() != '' &&
					$('#date-to').val() != '' &&
					$('#from-time option:selected').val() != '' &&
					$('#to-time option:selected').val() != '' &&
					(!$('#return_to_other_location').is(':checked') || $('#return_location').val() != '')) {

					let url = $(this).data('url');
					if (url != '') {
						let genUrl = '?pl=' + $('#pickup_location').val();
						if ($('#return_to_other_location').is(':checked')) {
							genUrl += '&rol=1';
							genUrl += '&rl=' + $('#return_location').val();
						} else {
							genUrl += '&rl=' + $('#pickup_location').val();
						}
						genUrl += '&pd=' + $('#date-from').val() + '-' + $('#from-time option:selected').val();
						genUrl += '&rd=' + $('#date-to').val() + '-' + $('#to-time option:selected').val();
						if ($('#age-25-70').is(':checked')) {
							genUrl += '&age_25_70=1';
						}
						if ($('#travel-abroad').is(':checked')) {
							genUrl += '&ta=1';
						}
						if ($('#pet-friendly').is(':checked')) {
							genUrl += '&pf=1';
						}

						if ($(this).data('source') == 'group-page') {
							genUrl += '&group=' + $(this).data('group');
						}

						window.location = url + genUrl;
					}
				}
			}

			$('#calendar-wrapper').addClass('visually-hidden');
			window.scrollTo(0, 0);
		},
		showCalendar(event) {
			const _this = event.data;
			event.preventDefault();

			var type = $(this).data('type')
			var element = this;

			$('#modal-calendar').modal('show');
			$('#modal-calendar').on('shown.bs.modal', function (e) {
				// $('#calendar-wrapper').removeClass('visually-hidden');
				// $('.daterangepicker').css("display", "block");

				$('#calendar-place').daterangepicker({
					alwaysShowCalendars: true,
					minDate: moment().add(2, 'hours'),
					//minDate: moment().add(1, 'days'),
					// startDate: moment().add(1, 'days'),
					// endDate: moment().add(3, 'days'),
					autoApply: true,
					autoUpdateInput: false,
					//singleDatePicker: true,
					locale: {
						format: 'DD/MM/YYYY'
					}
				});

				$('#calendar-place').on('apply.daterangepicker', function(ev, picker) {
					var startDate = picker.startDate;
					var endDate = picker.endDate;

					$('.date-from-btn').html(startDate.format('MMM D'));
					$('.date-to-btn').html(endDate.format('MMM D'));

					$('#date-from').val(startDate.format('DD/MM/YYYY'));
					$('#date-to').val(endDate.format('DD/MM/YYYY'));

					$('#from-time option:disabled').prop('disabled', false);
					$('#from-time').trigger('change.select2');

					// if (type == 0) {
					// 	$('#date-from').val(startDate.format('DD/MM/YYYY'));
					// } else {
					// 	$('#date-to').val(startDate.format('DD/MM/YYYY'));
					// }

					$('#modal-calendar').modal('hide');
				});
			});

		},
		returnToOtherLocation(event) {
			const _this = event.data;

			if ($(this).is(":checked")) {
				$('#return-to-other-location-cointainer').hide();
				$('#return-location-cointainer').show();
			} else {
				$('#return-location-cointainer').hide();
				$('#return-to-other-location-cointainer').show();
			}
		},
		showPickupLocations(event) {
			const _this = event.data;
			event.preventDefault();

			_this.pickupLocationsPopup.show();
		},
		showReturnLocations(event) {
			const _this = event.data;
			event.preventDefault();

			_this.returnLocationsPopup.show();
		},
		selectPickupLocation(event) {
			const _this = event.data;
			event.preventDefault();

			var code = $(this).data('code');
			var name = $(this).data('name');
			if (!code) { alert('Invalid Location!'); return value; }

			$('#pickup_location').val(code);
			$('#pickup-location-trigger').val(name);

			_this.pickupLocationsPopup.hide();
			window.scrollTo(0, 0);
		},
		selectReturnLocation(event) {
			const _this = event.data;
			event.preventDefault();

			var code = $(this).data('code');
			var name = $(this).data('name');
			if (!code) { alert('Invalid Location!'); return value; }

			$('#return_location').val(code);
			$('#return-location-trigger').val(name);

			_this.returnLocationsPopup.hide();
			window.scrollTo(0, 0);
		},
		checkAvailability(event) {
			const _this = event.data;
			let url = $(this).data('url');
			let type = $(this).data('type');
			if (!url || url == '' || url == null) {
				console.error('Invalid URL!');
				return false;
			}

			if ($('#pickup_location').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#pickup_location').data('alert')
				});
				return;
			}
			if ($('#return_to_other_location').is(':checked')) {
				if ($('#return_location').val() == '') {
					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: $('#return_location').data('alert')
					})
					return;
				}
			}
			if ($('#date-from').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#date-from').data('alert')
				});
				return false;
			}
			if ($('#date-to').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#date-to').data('alert')
				});
				return false;
			}
			if ($('#from-time option:selected').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#from-time').data('alert')
				});
				return false;
			}
			if ($('#to-time option:selected').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#to-time').data('alert')
				});
				return false;
			}
			if ($('#driver-age option:selected').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#driver-age').data('alert')
				});
				return false;
			}

			let genUrl = '?pl=' + $('#pickup_location').val();
			if ($('#return_to_other_location').is(':checked')) {
				genUrl += '&rol=1';
				genUrl += '&rl=' + $('#return_location').val();
			} else {
				genUrl += '&rl=' + $('#pickup_location').val();
			}
			genUrl += '&pd=' + $('#date-from').val() + '-' + $('#from-time option:selected').val();
			genUrl += '&rd=' + $('#date-to').val() + '-' + $('#to-time option:selected').val();
			genUrl += '&da=' + $('#driver-age option:selected').val();
			// if ($('#age-25-70 option:selected').val() != '') {
			// 	genUrl += '&age_25_70=' + $('#age-25-70 option:selected').val();
			// }
			// if ($('#travel-abroad').is(':checked')) {
			// 	genUrl += '&ta=1';
			// }
			// if ($('#pet-friendly').is(':checked')) {
			// 	genUrl += '&pf=1';
			// }

			if ($(this).data('source') == 'group-page' || $(this).data('source') == 'offer-page') {
				genUrl += '&group=' + $(this).data('group');
			}

			genUrl += '&tp=' + type;

			window.location = url + genUrl;
		}
    };

    if ($('.search-widget').length) {
        searchWidget.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/search-widget.js